import { Button, Datagrid, FunctionField, TextField, useNotify } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import { useState } from "react";
import { settings } from "app";
import { getTheme } from "customStyles/utils";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";

const GradeHistoryModal = ({ id, record }) => {
  const notify = useNotify();
  const [data, setData] = useState([]);
  const theme = getTheme(settings.tenant);

  const fetchData = async () => {
    try {
      const { data } = await dataProvider.customRequest(
        studentRequests.getStudentDisciplineExamGrades(id, record?.disciplineId),
      );

      setData(data);
    } catch (err) {
      notify(err.message || "Невалидна заявка!", { type: "error" });
    }
  };

  return (
    <ConfirmModal
      titleContent={"История на оценки"}
      isConfirmButton={false}
      onOpen={fetchData}
      triggerButton={
        <Button
          label="Виж история"
          variant="text"
          sx={{ textDecoration: "underline", ml: "-10px" }}
          startIcon={null}
        />
      }
    >
      <Datagrid
        data={data}
        rowClick={false}
        bulkActionButtons={false}
        sx={settings.style.secondaryDatagrid}
      >
        <TextField
          label="Дата на изпит"
          source="examDate"
          required={true}
        />
        <FunctionField
          label="Оценка"
          render={rec => (
            <TextField
              color={+rec.grade === 2 ? theme.palette.error.primary : null}
              source="gradeFullText"
              emptyText="-"
            />
          )}
        />
      </Datagrid>
    </ConfirmModal>
  );
};

export default GradeHistoryModal;
